import { COMPONENTS } from '../../../components/components.registry';
import { HistoryConfig } from '../../../models';

export const DEFAULT_HISTORY_CONFIG: HistoryConfig = {
  components: {
    container: COMPONENTS.PURE.Suggestions,
    item: COMPONENTS.PURE.HistorySuggestion,
    header: null,
    toggle: COMPONENTS.PURE.SlideToggle,
    clearItemIcon: COMPONENTS.PURE.CrossIcon,
    icon: null,
    clearAll: {
      button: COMPONENTS.PURE.EventButton,
      icon: COMPONENTS.PURE.CrossIcon
    }
  },
  searchable: true,
  queryHistorySize: 10,
  clickedResultHistorySize: 10,
  clickedResultIdFieldForHistory: 'tagging.click.params.productId',
  sessionQueryHistory: {
    size: 50,
    ttl: 30 * 60 * 1000
  }
};
